"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatUrl_1 = require("./util/formatUrl");
var appHistory = {
    push: function (url, hashType) {
        window.history.pushState({}, null, formatUrl_1.default(url, hashType));
    },
    replace: function (url, hashType) {
        window.history.replaceState({}, null, formatUrl_1.default(url, hashType));
    },
};
exports.default = appHistory;
